// Helper puri per decidere cosa renderizzare in dettaglio encounter (admin + PDF).
// Tre rami canonici (vedi spec sezione 4.1):
//   1. translation_it != null               → main = translation, original = content
//   2. translation_it == null && encounter è IT → main = content, original = null
//   3. translation_it == null && encounter NON-IT → main = content (fallback), badge "missing"
//
// La presenza/assenza dell'originale (ramo 1 vs 2/3) è la chiave dell'UX:
// solo nel ramo 1 il toggle "mostra originale" ha qualcosa da rivelare.
import { isItalianLang } from './lang.js';
export function pickMainText(msg, _encounterLang) {
    if (msg.content_translation_it != null && msg.content_translation_it !== '') {
        return msg.content_translation_it;
    }
    return msg.content;
}
export function pickOriginalText(msg, _encounterLang) {
    // Ritorna l'originale solo se è disponibile da affiancare ALLA TRADUZIONE.
    // Se non c'è traduzione, l'originale è già il main → nulla da affiancare.
    if (msg.content_translation_it != null && msg.content_translation_it !== '') {
        return msg.content;
    }
    return null;
}
export function needsTranslationButMissing(msg, encounterLang) {
    // Vero solo nel ramo 3: encounter dichiarato non-IT, ma manca la traduzione.
    // Edge case: language_detected null → non sappiamo, non allarmiamo.
    if (msg.content_translation_it != null && msg.content_translation_it !== '')
        return false;
    if (encounterLang == null)
        return false;
    return !isItalianLang(encounterLang);
}
export function hasAnyOriginalAvailable(input) {
    // Toggle/dropdown si mostrano solo se c'è almeno una traduzione affiancabile.
    // Più robusto della sola lettura di language_detected: copre encounter "vecchi"
    // con language_detected null e backfill incompleti.
    for (const m of input.messages) {
        if (m.content_translation_it != null && m.content_translation_it !== '')
            return true;
    }
    for (const c of input.captured) {
        if (c.translation_it != null && c.translation_it !== '')
            return true;
    }
    return false;
}
//# sourceMappingURL=encounterRendering.js.map